<script>
// On Balance Volume indicator

import { Overlay } from '../../'
import { drawIndicatorPlot, drawSmoothingPlots } from '../../workspace/indicator-plots.mjs'

export default {
    name: 'OBV',
    mixins: [Overlay],
    methods: {
        meta_info() {
            return {
                author: 'TradingCandle', version: '1.0.0',
                desc: 'On Balance Volume',
                preset: {
                    name: 'OBV',
                    side: 'offchart',
                    settings: {
                        lineWidth: 1.5,
                        color: '#ff9800'
                    }
                }
            }
        },
        draw(ctx) {
            drawIndicatorPlot(ctx, this.$props.data, this.$props.layout, this.sett, 0, {color:this.color,width:this.line_width})
            drawSmoothingPlots(ctx,this.data,this.layout,this.sett)
        },
        use_for() { return ['OBV'] },
        legend(values) {
            return [{
                value: values[1] ? values[1].toFixed(0) : '0',
                color: this.color
            }]
        },
        calc() {
            return {
                props: {},
                update: `
                    let change = close[0] > close[1] ? vol[0] : close[0] < close[1] ? -vol[0] : 0
                    return [cum(ts(change))[0]]
                `
            }
        }
    },
    computed: {
        sett() { return this.$props.settings },
        line_width() { return this.sett.lineWidth || 1.5 },
        color() { return this.sett.color || '#ff9800' }
    }
}
</script>
